"use client"

import { useAppSelector } from "@/hooks/redux"
import { TitleProps } from "antd/es/typography/Title"
import NextImage from "../NextImage"
import Text from "../Typography/Text"

const ProductLabel = ({ labelSetting: _labelSetting, value, ...props }: TitleProps & { labelSetting: { type: string, image: string, text: string }, value?: any }) => {
  const productLabelSetting = useAppSelector(state => state.store.store_setting.data.product_labels)
  const labelSetting = _labelSetting || { type: 'text', text: "", image: "" }

  if (!!labelSetting.image && labelSetting?.type === 'image') {
    return (
      <NextImage
        hiddenSpin
        src={labelSetting.image}
        height={200}
        width={200}
        style={{ marginBlock: 15, objectFit: 'contain', maxHeight: "4rem", alignSelf: 'start', marginBottom: '1rem', objectPosition: 'left' }}
        alt={`Label image`}
      />
    )
  }

  return (
    <Text
      {...props}
      style={{
        marginBlock: '1rem',
        fontSize: `${productLabelSetting?.size / 10}rem`,
        fontFamily: productLabelSetting.font_name ? `${productLabelSetting.font_name} !important` : undefined,
        color: productLabelSetting.color,
        width: '100%',
        ...(productLabelSetting.decorator === 'bold' ? {
          fontWeight: 'bold'
        } : {}),
        ...(productLabelSetting.decorator === 'italic' ? {
          fontStyle: 'italic'
        } : {}),
        ...(productLabelSetting.decorator === 'underline' ? {
          textDecoration: 'underline'
        } : {}),
        ...props.style
      }}
    >
      {labelSetting.text}{value ? `: ${value}` : ''}
    </Text>
  )
}

export default ProductLabel